import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import store from 'modules/store';

const rootReducer = combineReducers({
    api:                     require('modules/api').apiReducer,
    auth:                    require('modules/auth').reducer,
    awsReservations:         require('modules/awsReservations').reducer,
    awsTickets:              require('modules/awsTickets').reducer,
    alertsForm:              require('modules/alertsForm').reducer,
    backups:                 require('modules/backups').reducer,
    cookiesManager:          require('modules/cookiesManager').reducer,
    catalogRequest:          require('modules/catalogRequest').reducer,
    credentials:             require('modules/credentials').reducer,
    cloudBillingBookmarks:   require('modules/cloudBillingBookmarks').reducer,
    cloudBillingEntities:    require('modules/cloudBillingEntities').reducer,
    cloudBillingCharts:      require('modules/cloudBillingCharts').reducer,
    cloudBillingPersists:    require('modules/cloudBillingPersists').reducer,
    dashboard:               require('modules/dashboard').reducer,
    language:                require('modules/language').reducer,
    impersonateUser:         require('modules/impersonateUser').reducer,
    infrastructureResources: require('modules/infrastructureResources').reducer,
    notifications:           require('modules/notifications').reducer,
    monitoring:              require('modules/monitoring').reducer,
    newFeatures:             require('modules/newFeatures').reducer,
    period:                  require('modules/period').reducer,
    reportsUI:               require('modules/reportsUI').reducer,
    routing:                 routerReducer,
    store,
    ui:                      require('modules/ui').reducer,
    servicenowForm:          require('modules/servicenowForm').reducer,
    updateApp:               require('modules/updateApp').reducer,
    userCredentials:         require('modules/userCredentials').reducer,
    websockets:              require('modules/websockets').reducer,
    storage:                 require('modules/storage').reducer,
    cmdb:                    require('modules/cmdb').reducer,
    pageAnalytics:           require('modules/pageAnalytics').reducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/index.js